module.exports = __webpack_public_path__ + "static/media/studio-pro-step2.a8b1b238.png";